import React, { useEffect, useState } from "react";

const SvgIcon = ({ src, alt = "", sx = {}, ...props }) => (
  <img src={src} alt={alt} style={sx} {...props} />
);

export default function IconRenderer({ keyword, sx }) {
  const [iconElement, setIconElement] = useState(null);

  useEffect(() => {
    const loadIcon = async () => {
      try {
        const module = await import(
          /* webpackMode: "lazy" */
          `../assets/${keyword}.svg`
        );
        setIconElement(
          <SvgIcon src={module.default} alt={`${keyword}-icon`} sx={sx} />
        );
      } catch (err) {
        console.warn(`No SVG found for "${keyword}", using inline fallback`, err);
        setIconElement(
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="gray"
            style={sx}
          >
            <circle cx="12" cy="12" r="10" />
          </svg>
        );
      }
    };

    loadIcon();
  }, [keyword, sx]);

  return iconElement;
}
